import { userAxios } from '../../index'

/**
 * Comisiones y PatientFlow. Permiso membership-commissions.manage.
 * Las fechas van en m-d-Y. El sistema no paga: el admin marca como pagado.
 */

const report = async ({ cutDate, status }) => {
  const response = await userAxios.get('membership-commissions/report', {
    params: { cut_date: cutDate, status },
  })
  return response.data
}

const detail = async ({ cutDate, status, beneficiaryType, beneficiaryUserId }) => {
  const response = await userAxios.get('membership-commissions/detail', {
    params: {
      cut_date: cutDate,
      status,
      beneficiary_type: beneficiaryType,
      beneficiary_user_id: beneficiaryUserId,
    },
  })
  return response.data
}

/** Devuelve el archivo .xlsx. */
const exportFile = async ({ cutDate, status }) => {
  const response = await userAxios.get('membership-commissions/export', {
    params: { cut_date: cutDate, status },
    responseType: 'blob',
  })
  return response
}

const markPaid = async ({ cutDate, paidAt, beneficiaries }) => {
  const body = { cut_date: cutDate, paid_at: paidAt }
  if (Array.isArray(beneficiaries) && beneficiaries.length) body.beneficiaries = beneficiaries
  const response = await userAxios.post('membership-commissions/mark-paid', body)
  return response.data
}

const rates = async () => {
  const response = await userAxios.get('membership-commission-rates')
  return response.data
}

const createRate = async payload => {
  const response = await userAxios.post('membership-commission-rates', payload)
  return response.data
}

const createEliteRule = async payload => {
  const response = await userAxios.post('membership-commission-elite-rules', payload)
  return response.data
}

const createPatientFlowRate = async payload => {
  const response = await userAxios.post('patient-flow-rates', payload)
  return response.data
}

export default {
  report,
  detail,
  exportFile,
  markPaid,
  rates,
  createRate,
  createEliteRule,
  createPatientFlowRate,
}
